var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4475 10.8033C36.8056 10.8033 40.3343 14.3472 40.3343 18.7241C40.3343 26.6135 32.2206 35.6187 24.5606 39.2256C17.1745 35.7523 9.35811 28.0437 8.81824 19.6435C8.53656 15.2587 11.588 11.2354 15.9461 10.8347C19.7722 10.4889 23.2305 12.9092 24.3494 16.351C24.4198 16.5632 24.7171 16.5632 24.7797 16.351C25.8282 13.1371 28.9188 10.8033 32.4475 10.8033ZM32.4475 7C29.4586 7 26.6732 8.13155 24.5606 10.0096C22.4481 8.13155 19.6627 7 16.6738 7C10.2344 7 5 12.257 5 18.7241C5 23.6668 7.04213 28.7194 10.8995 33.3478C14.1309 37.2218 18.4108 40.53 22.9567 42.6674L24.5606 43.4217L26.1646 42.6674C30.5227 40.6164 34.9278 37.0882 38.2531 32.9785C43.0963 26.9907 44.1135 21.9223 44.1135 18.7241C44.1135 12.257 38.879 7 32.4397 7H32.4475Z",
    fill: "#9BABD9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.3bf214b4b38c10700a8ff9ea97baa16a.svg";
export { ForwardRef as ReactComponent };